import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import PdfViewer from "../../paginas/pdf/View";

const ElectronicInvoice = ({ filteredData, numberInvoice, prefijo }) => {
  const [open, setOpen] = useState(false);
  const [loadingRow, setLoadingRow] = useState(false);
  const [base64, setBase64] = useState("");
  const [invoice, setInvoice] = useState("");

  console.log(filteredData);

  const handleSearchClick = async () => {
    try {
      setLoadingRow(true);
      setTimeout(() => {
        setBase64(filteredData.pdf64);
        setInvoice(numberInvoice);
        setLoadingRow(false);
        setOpen(true);
      }, 2000);
    } catch (error) {
      toast.error("Ocurrió un error al buscar la información.");
      console.error("Error al consumir el servicio:", error);
    }
  };

  return (
    <>
      {filteredData ? (
        <>
          <table className="tabla">
            <thead>
              <tr>
                <th>Prefijo</th>
                <th>Factura Electrónica</th>
                <th>Representación Grafica</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{prefijo}</td>
                <td>{numberInvoice}</td>
                <td>
                  {filteredData !== "" ? (
                    <>
                      {loadingRow ? (
                        <div className="container-sniper"></div>
                      ) : (
                        <FaSearch
                          style={{ cursor: "pointer", color: "#008b9c" }}
                          onClick={() => handleSearchClick(filteredData)}
                        />
                      )}
                    </>
                  ) : (
                    <>A la espera envio a la DIAN</>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          {base64 ? (
            <Modal show={open} onHide={() => setOpen(false)}>
              <Modal.Header closeButton>
                <Modal.Title style={{ color: "#008b9c" }}>
                  Representación Grafica
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PdfViewer base64String={base64} invoice={invoice} prefijo={prefijo} />
              </Modal.Body>
            </Modal>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default ElectronicInvoice;
